// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "menu-row td.navinfo span {\n  font-weight: bold;\n}\nmenu-row .menu-button {\n  padding: 4px 6px 4px 6px;\n  cursor: pointer;\n}", ""]);
// Exports
module.exports = exports;
